export const exchangeForOrderStatusValues = {
  pending: 'pending',
  created: 'created',
}

export const exchangeForOrderStatusOptions = [
  { label: 'Pendiente', value: exchangeForOrderStatusValues.pending },
  { label: 'Creado', value: exchangeForOrderStatusValues.created },
]
